module.exports = __webpack_public_path__ + "img/18.2026bf40.jpg";